export const RealtimeMessageType = {
  // NOTEBOOK
  // Keep in sync with benchling/notebook/realtime/constants.py
  ENTRY_UPDATE: 'entry_update',
  LOCK_UPDATE: 'lock_update',
  REVIEW_UPDATE: 'review_update',
  WORKSHEET_UPDATE: 'worksheet_update',
  WORKSHEET_STEP_REOPENED: 'worksheet_step_reopened',
  TABLE_API_PENDING_ROWS_UPDATE: 'table_api_pending_rows_update',
  // LLM
  LLM_RESPONSE_CHUNK: 'llm_response_chunk',
  LLM_RESPONSE_COMPLETE: 'llm_response_complete',
  CHAT_NAME_UPDATED: 'chat_name_updated',
  // Add new realtime message types here and link to the corresponding Python constants
} as const;

export type RealtimeMessageType = (typeof RealtimeMessageType)[keyof typeof RealtimeMessageType];
